import { Validator } from 'vee-validate'
import SubjectMatterInput from './subjectMatter'

export default function install() {
  Validator.extend('subjectMatter', SubjectMatterInput)
}
